/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureCspMaster extends models.ServiceAccountNativeDetailsBaseForAzure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureCspMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureCspMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureCspMaster>): ServiceAccountNativeDetailsForAzureCspMaster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureCspMaster(), model);
        ServiceAccountNativeDetailsForAzureCspMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureCspMaster>): ServiceAccountNativeDetailsForAzureCspMaster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureCspMaster.newInstance(<ServiceAccountNativeDetailsForAzureCspMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureCspMaster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureCspMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureCspMaster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureCspMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.storage_account) {
            models.StorageAccountDetailsForAzureCspMaster.fixupPrototype(this.storage_account);
        }
    }

    /**
     * Cost Report Type.
     */
    cost_report_type: models.CspStorageType;

    storage_account: models.StorageAccountDetailsForAzureCspMaster;

}
